<template>
  <div id="app">
    <nprogress-container />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';

console.log('test cicd.');

export default {
  name: 'app',
  components: {
    NprogressContainer,
  },
};
</script>

<style lang="less">
@import './assets/css/myskin.less';

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}

body {
  margin: 0px;
  padding: 0px;
  font-family: 'DINPro-Medium', -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  -webkit-font-smoothing: antialiased;

  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

a {
  cursor: pointer;
}

// overrides el-message-box__btns:
// define message-box btns direction
.el-message-box__btns {
  direction: rtl;
}
.el-message-box__btns button:nth-child(1) {
  margin-left: 10px;
}
.el-message-box__btns button:nth-child(2) {
  margin-left: 0;
}

.el-submenu [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar {
  background: #f2f2f2;
  padding: 10px;
  //border:1px solid #dfe6ec;
  margin: 10px 0px;
  .el-form-item {
    margin-bottom: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
input::-webkit-input-placeholder {
  /* 强行设置placeholder颜色 */
  color: #a9abb0 !important;
}
.el-pagination {
  font-weight: 500;
}
// 强行设置预览弹窗的z-index为20000，防止饿了么弹窗高于这个z-index
.viewer-container {
  z-index: 20000 !important;
}

@keyframes active-twinkling {
  0% {
    background: #fff;
  }
  100% {
    background: #f7f0c7;
  }
}

@-webkit-keyframes active-twinkling {
  0% {
    background: #fff;
  }
  100% {
    background: #f7f0c7;
  }
}
</style>
